import { createContext, useState, useMemo } from 'react';
import { useModal } from 'src/services/modal';
import useSessionState from 'src/services/sessionState';

const BusinessContext = createContext();
export default BusinessContext;

const contactInitalValue = {
  partyName: '',
  emailAddr: '',
  phone: '',
  cellPhone: '',
  addrStreet: '',
  addrCity: '',
  addrState: '',
  addrZip: '',
  partyType: '',
};

/**

The BusinessProvider component provides context for the contact modal in the application.
It handles opening and closing the modal, storing and updating the contact list and selected contact, and tracking whether the modal is in update or create mode.
@param {Object} props - The properties of the component.
@param {Object} props.children - The children to be rendered within the provider.
@return {ReactElement} - The BusinessProvider component.
*/
export const BusinessProvider = (props) => {
  const [sameForMail, setSameForMail] = useSessionState('sameForMail', false);
  const [contactAgreement, setContactAgreement] = useSessionState('contactAgreement', false);

  const contactModalController = useModal();
  const [updatingContact, setUpdatingContact] = useState(false);

  const [contacts, setContacts] = useState([]);
  const [selectedContact, setSelectedContact] = useState(contactInitalValue);

  const handleContactModalClose = useMemo(() => {
    return () => {
      setUpdatingContact(null);
      setSelectedContact(contactInitalValue);
      contactModalController.closeModal();
    };
  }, [contactModalController]);

  const value = useMemo(
    () => ({
      handleClose: handleContactModalClose,
      initialValues: selectedContact,
      open: contactModalController.open,
      contacts,
      setContacts,
      updating: updatingContact,
      openModal: contactModalController.openModal,
      setSelectedContact,
      setUpdatingContact,
      setSameForMail,
      setContactAgreement,
      sameForMail,
      contactAgreement,
    }),
    [
      contactAgreement,
      setContactAgreement,
      sameForMail,
      setSameForMail,
      contactModalController.open,
      contactModalController.openModal,
      contacts,
      handleContactModalClose,
      selectedContact,
      updatingContact,
    ]
  );

  return <BusinessContext.Provider value={value}>{props.children}</BusinessContext.Provider>;
};
